import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';
import breadcrumbs from '../../../json/breadcrumbs.json';

interface Breadcrumb {
  label: string;
  route: string | null;
  parent: string;
}

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    imports: [
        NgIf,
        NgFor,
        RouterLink,
    ],
})
export class BreadcrumbsComponent implements OnInit {
  public trail: Breadcrumb[] = [];

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.parseBreadcrumbs(String(this.activatedRoute.routeConfig?.path));
    this.trail = this.trail.reverse();
  }

  private parseBreadcrumbs(route: string): void {
    type CrumbKey = keyof typeof breadcrumbs;
    const currentRoute = route as CrumbKey;

    if (breadcrumbs[currentRoute]) {
      // copy array
      const currentCrumb = Object.assign(
        [],
        <Breadcrumb>breadcrumbs[currentRoute]
      );

      // crumb has a route param, so need to turn that into a proper value i.e.
      // turn :faqUID into whatever value is currently passed for that
      if (currentCrumb.label.charAt(0) === ':') {
        currentCrumb.label = this.getRouteParam(
          currentCrumb.label.replace(':', '')
        ).replaceAll('-', ' ');
      }
      this.trail.push(currentCrumb);
    }

    if (breadcrumbs[currentRoute]?.parent) {
      this.parseBreadcrumbs(breadcrumbs[currentRoute].parent);
    }
  }

  private getRouteParam(param: string): string {
    const routeParams = this.activatedRoute.snapshot.paramMap;
    return String(routeParams.get(param)) ?? '';
  }
}
